import React from 'react';

type IconCheckProps = { size?: number } & React.SVGAttributes<SVGElement>;

export default function IconCheck({ size = 16, ...rest }: IconCheckProps) {
  return (
    <svg width={size} height={size} {...rest} viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="check">
        <path
          id="Vector"
          d="M6.36667 11.7167C6.27778 11.7167 6.19444 11.7027 6.11667 11.6747C6.03889 11.6471 5.96667 11.6 5.9 11.5333L3.03333 8.66666C2.91111 8.54444 2.85267 8.386 2.858 8.19133C2.86378 7.99711 2.92778 7.83888 3.05 7.71666C3.17222 7.59444 3.32778 7.53333 3.51667 7.53333C3.70556 7.53333 3.86111 7.59444 3.98333 7.71666L6.36667 10.1L12.0167 4.45C12.1389 4.32777 12.2973 4.26666 12.492 4.26666C12.6862 4.26666 12.8444 4.32777 12.9667 4.45C13.0889 4.57222 13.15 4.73044 13.15 4.92466C13.15 5.11933 13.0889 5.27777 12.9667 5.4L6.83333 11.5333C6.76667 11.6 6.69444 11.6471 6.61667 11.6747C6.53889 11.7027 6.45556 11.7167 6.36667 11.7167Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
